import Vue        from 'vue'
import * as Store from '@/api/datastore/Store'

const DataStore = Vue.observable({
  User: null,
  ...Store
})

export default DataStore
